import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { toast } from 'sonner';

const CTASection = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);
    
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      const response = await fetch(`${backendUrl}/api/waitlist`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source: 'cta_section' }),
      });

      const data = await response.json();
      
      if (response.ok) {
        toast.success(data.message || 'Děkujeme! Brzy se vám ozveme.');
        setEmail('');
      } else {
        toast.error(data.detail || 'Něco se pokazilo.');
      }
    } catch (error) {
      toast.error('Nepodařilo se odeslat. Zkuste to prosím znovu.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-[color:var(--primary-50)] to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-[color:var(--text-primary)] mb-4">
          Připraveni začít?
        </h2>
        <p className="text-lg text-[color:var(--text-secondary)] mb-8">
          Kontaktujte nás pro více informací nebo se zaregistrujte na bezplatný webinář.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="/#webinar">
            <button className="bg-[color:var(--primary-500)] hover:bg-[color:var(--primary-600)] text-white font-semibold px-8 py-3 rounded-xl transition-all shadow-md hover:shadow-lg">
              Webinář zdarma
            </button>
          </a>
          <a href="https://app.skolobot.cz/register" target="_blank" rel="noopener noreferrer">
            <button className="bg-white border-2 border-[color:var(--primary-500)] text-[color:var(--primary-600)] font-semibold px-8 py-3 rounded-xl hover:bg-[color:var(--primary-50)] transition-all">
              Vyzkoušet zdarma
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;